"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkInfoTranslations = void 0;
exports.networkInfoTranslations = {
    noInternet: "Oops! No Internet",
    checkConnection: "Please check your network connection",
    tryAgain: "Try again",
    noSocketConnection: "Connection lost",
    tapToConnect: "Tap to connect",
    connect: "Connect",
    connecting: "Connecting",
    reconnecting: "Reconnecting...",
    tapToRetry: "Tap to retry",
    offline: "You're offline",
    offlineReason: "This may be caused by an unstable internet connection or temporary server network issues.",
    willTryConnectingAgain: "We will keep trying to reconnect in a few seconds.",
};
